import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi} from "@angular/common/http";
import {provideOAuthClient} from "angular-oauth2-oidc";
import {environment} from "../environments/environment";
import {TokenInterceptor} from "./api-interceptor.service";
import {BlockUIModule} from "ng-block-ui";

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideOAuthClient(/*{
      resourceServer: {
        allowedUrls: ['http://localhost:9090/api/v1/serverInfo'],
        sendAccessToken: true,
      }
    }*/),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    provideRouter(routes),
    importProvidersFrom(BlockUIModule.forRoot()),
  ]
};
